module.exports = __webpack_public_path__ + "media/Video 122.cf2d6cd5.mp4";